import(/* webpackMode: "eager" */ "/home/runner/work/becoming-wind-v2/becoming-wind-v2/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/becoming-wind-v2/becoming-wind-v2/src/components/AboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/becoming-wind-v2/becoming-wind-v2/src/components/BandSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/becoming-wind-v2/becoming-wind-v2/src/components/Gallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/becoming-wind-v2/becoming-wind-v2/src/components/Hero.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/becoming-wind-v2/becoming-wind-v2/src/components/MusicSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/becoming-wind-v2/becoming-wind-v2/src/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/becoming-wind-v2/becoming-wind-v2/src/components/NextEventSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/becoming-wind-v2/becoming-wind-v2/src/components/UpcomingEventsSection.tsx");
